<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row  m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">
              <div class="row">

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <TrafficGroupMultiselect :multiple="true" small v-model="trafficGroupsFilter"></TrafficGroupMultiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="statuses"
                                   class="multiselect-sm"
                                   v-model="status"
                                   :options="['active', 'expired', 'deleted']"
                                   :custom-label="(opt) => helper.trans(`labels.${opt}`)"
                                   :multiple="false"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.status')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="card card-body">
              <div class="overflow-auto">
                <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
                  <thead>
                  <tr>
                    <th class="text-capitalize-first">{{ helper.trans('labels.id') }}</th>
                    <th class="text-capitalize-first" style="width: 10px"></th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.rewards') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.start_at') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.expire_at') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.traffic_group') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.traders') }}</th>
                    <th class="text-end">
                      <button v-if="store.getters.isAdmin" type="button" v-on:click="showEditModal()" class="btn btn-outline-primary btn-sm text-capitalize">{{ helper.trans('button.create') }}</button>
                      <b-modal
                               :title="createModalTitle"
                               :modelValue="createModal"
                               body-class="pt-0"
                               @update:modelValue="createModal = $event"
                      >
                        <template #default>
                          <AdditionalRewardSettingsForm ref="createForm"></AdditionalRewardSettingsForm>
                        </template>
                        <template #footer>
                          <button type="button" v-on:click="createModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
                          <LoaderWrapper ref="loaderCreateFrom" :zoom="0.5">
                            <button type="button" @click="save()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans('button.save') }}</button>
                          </LoaderWrapper>
                        </template>
                      </b-modal>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in response.items" :key="item.id" class="">
                    <td>{{ item.id }}</td>
                    <td>
                      <i v-if="item.isDeleted" v-b-tooltip.hover :title="helper.trans('labels.deleted')" class="fa fa-ban text-danger"></i>
                      <i v-else-if="item.isActive" v-b-tooltip.hover :title="helper.trans('labels.active')" class="fa fa-circle-play text-success"></i>
                      <i v-else v-b-tooltip.hover :title="helper.trans('labels.expired')" class="fa fa-circle-stop text-secondary"></i>
                    </td>
                    <td>
                      {{ helper.floatToPercent(item.traderRewardFee) }}%
                    </td>
                    <td>
                      {{ dateHelper.format(item.startAt)}}
                    </td>
                    <td>
                      {{ dateHelper.format(item.expiredAt)}}
                    </td>

                    <td>
                      <div v-if="item._trafficGroup">
                        {{ item._trafficGroup!.name}} - {{ item._trafficGroup!.type}}
                      </div>
                    </td>
                    <td>
                      <span v-for="trader in item._traders" :key="trader.id" class="me-2">{{trader.name}}</span>
                    </td>
                    <td class="text-end">
                      <button  v-if="store.getters.isAdmin" type="button" @click="showEditModal(item)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize"><i class="fa fa-pencil"></i> {{helper.trans('button.edit')}}</button>
                      <button  v-if="store.getters.isAdmin" type="button" @click="deletePriority(item.id)" class="btn btn-sm btn-outline-danger text-nowrap text-capitalize ms-2"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <b-pagination
                  v-if="response.totalCount > response.items.length"
                  v-model="page"
                  :total-rows="response.totalCount"
                  :per-page="response.limit"
                  :limit="20"
                  @update:modelValue="loadList()"
                  prev-text="Back"
                  next-text="Next"
                  align="start"
                  first-number
                  hide-goto-end-buttons
                  hide-ellipsis
                ></b-pagination>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>


    <ConfirmModal ref="confirmModal"></ConfirmModal>
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {computed, defineComponent, onMounted, reactive, ref, toRefs} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import ConfirmModal, {ConfirmModalProps} from "@/components/ConfirmModal.vue";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import {BPagination} from "bootstrap-vue-3";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import {Dictionary} from "@/types";
import PaginationDTO from "@/models/PaginationDTO";
import TrafficGroupDTO from "@/models/TrafficGroupDTO";
import UserNameLabel from "@/components/UserNameLabel.vue";
import TraderMultiselect from "@/components/TraderMultiselect.vue";
import Multiselect from "vue-multiselect";
import TrafficGroupMultiselect from "@/components/TrafficGroupMultiselect.vue";
import TrafficGroupAdditionalRewardSettingsDTO from "@/models/TrafficGroupAdditionalRewardSettingsDTO";
import AdditionalRewardSettingsFormDTO from "@/models/form/AdditionalRewardSettingsFormDTO";
import AdditionalRewardSettingsForm from "@/components/Form/AdditionalRewardSettingsForm.vue";
import TraderDTO from "@/models/TraderDTO";

const api = new APIClient();
const notification = useNotification()
const defaultForm = {
  id: null,
  trafficGroup: null,
  traderRewardFeePercent: null,
  expiredAt: null,
  startAt: null,
  traders: []
} as AdditionalRewardSettingsFormDTO

export default defineComponent({
  components: {
    TrafficGroupMultiselect,
    Multiselect,
    TraderMultiselect,
    AdditionalRewardSettingsForm,
    UserNameLabel,
    LoaderWrapper,
    ConfirmModal,
    CopyButton,
    BPagination,
  },
  setup() {
    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderCreateFrom = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const createForm = ref<InstanceType<typeof AdditionalRewardSettingsForm> | null>(null)
    const confirmModal = ref<InstanceType<typeof ConfirmModal> | null>(null)

    const state = reactive({
      trafficGroups: [] as TrafficGroupDTO[],
      trafficGroupsFilter: [] as TrafficGroupDTO[],
      status: 'active' as string,
      requestDTO: {
        isDeleted: false,
        isActive: true,
        traderIds: [],
        trafficGroupIds: []
      } as any,
      createModalTitle: '',
      createModal: false,
      page: 1,
      response: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<TrafficGroupAdditionalRewardSettingsDTO>
    });

    const loadList = async () => {
      loader.value?.show()
      state.requestDTO.trafficGroupIds = state.trafficGroupsFilter.map((value) => value.id)
      state.requestDTO.isDeleted = false;
      state.requestDTO.isActive = false;
      if (state.status === 'active') {
        state.requestDTO.isActive = true;
      } else if (state.status === 'expired') {
        state.requestDTO.isActive = false;
      } else if (state.status === 'deleted') {
        state.requestDTO.isDeleted = true;
      }

      state.response.offset = state.response.limit * (state.page - 1)
      state.response = await api.call.additionalRewardSettings.list(state.response, state.requestDTO);

      let traderIds = [];
      let trafficGroupIds = [];
      for (const item of state.response.items) {
        if (item.trafficGroupId) {
          trafficGroupIds.push(item.trafficGroupId)
        }

        for (const traderId of item.traderIds) {
          traderIds.push(traderId)
        }
      }

      let traders = {} as Dictionary<TraderDTO>;
      if (traderIds.length > 0) {
        for (const trader of (await api.traders({offset:0, limit: traderIds.length} as PaginationDTO, {ids: traderIds})).items) {
          traders[trader.id] = trader
        }
      }

      let trafficGroups = {} as Dictionary<TrafficGroupDTO>;
      if (trafficGroupIds.length > 0) {
        for (const rule of (await api.call.trafficGroups.list({offset:0, limit: trafficGroupIds.length} as PaginationDTO, {ids: trafficGroupIds})).items) {
          trafficGroups[rule.id] = rule
        }
      }

      for (const item of state.response.items) {
        if (item.trafficGroupId) {
          item._trafficGroup = trafficGroups[item.trafficGroupId] ?? null;
        }

        item._traders = []
        for (const traderId of item.traderIds) {
          const trader = traders[traderId] ?? null
          if (trader) {
            item._traders.push(trader)
          }
        }
      }

      loader.value?.hide()
    }

    const deletePriority = (id:number) => {
      confirmModal.value?.show({
        title: helper.trans('labels.delete_confirm'),
        okTitle: null,
        cancelTitle: null,
        onOkClick: async () => {
          try {
            await api.call.additionalRewardSettings.delete(id);
            loadList()
          } finally {
          }
        }
      } as ConfirmModalProps);
    }

    const showEditModal = async (dto: TrafficGroupAdditionalRewardSettingsDTO|null = null) => {
      if (dto) {
        state.createModalTitle = helper.trans("labels.edit_additional_reward_settings", {id: dto.id})
        createForm.value?.setForm({
          ...defaultForm,
          ...dto,
          expiredAt: dateHelper.format(dto.expiredAt),
          startAt: dateHelper.format(dto.startAt),
          traderRewardFeePercent: helper.floatToPercent(dto.traderRewardFee).toString(),
          trafficGroup: dto._trafficGroup,
          traders: dto._traders
        } as AdditionalRewardSettingsFormDTO)
      } else {
        state.createModalTitle = helper.trans("labels.create_additional_reward_settings")
        createForm.value?.setForm({...defaultForm} as AdditionalRewardSettingsFormDTO)
      }

      state.createModal = true;
    }

    const save = () => {
      loaderCreateFrom.value?.show()

      createForm.value!.save()
        .then(() => {
          state.createModal = false;
          loadList();
        })
        .finally(() => {
          loaderCreateFrom.value?.hide();
        })
    }

    const applyFilters = async () => {
      loadList()
    }

    const clearFilters = async () => {
      state.trafficGroupsFilter = [];
      state.status = 'active'
      state.requestDTO = {
        isDeleted: false,
        isActive: true,
        traderIds: [],
        trafficGroupIds: []
      }
    }

    onMounted(async () => {
      loadList()
      state.trafficGroups = await api.call.trafficGroups.all()
    });

    return {
      ...toRefs(state),
      store,
      loader,
      loaderCreateFrom,
      dateHelper,
      numberFormatter,
      confirmModal,
      helper,
      createForm,
      save,
      showEditModal,
      loadList,
      deletePriority,
      clearFilters,
      applyFilters
    }
  }
})
</script>
